import {
  OutlinedTextFieldProps,
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput,
} from '@mui/material'
import React from 'react'
import { colors } from '../themes/colors'

export interface TextFieldProps extends OutlinedTextFieldProps {
  testId?: string
  helperTextColor?: string
}

const TextField = ({
  label,
  error,
  helperText,
  placeholder,
  inputProps,
  InputProps,
  InputLabelProps,
  value,
  onChange,
  testId,
  multiline,
  minRows,
  maxRows,
  autoFocus,
  helperTextColor,
  sx,
}: TextFieldProps) => {
  return (
    <FormControl fullWidth>
      {label && <FormLabel {...InputLabelProps}>{label}</FormLabel>}
      <OutlinedInput
        sx={sx}
        ref={InputProps?.ref}
        {...InputProps}
        inputProps={{
          maxLength: 100,
          ...inputProps,
        }}
        placeholder={placeholder}
        error={error}
        value={value}
        onChange={onChange}
        data-testid={testId}
        multiline={multiline}
        minRows={minRows}
        maxRows={maxRows}
        autoFocus={autoFocus}
      />
      <FormHelperText error={error} sx={{ color: helperTextColor ?? colors.grey800 }}>
        {helperText}
      </FormHelperText>
    </FormControl>
  )
}

export default TextField
